import { toContentSeenKey } from '@/helpers/feedFolderResolver';

const localStorageKey = 'storeeel_content_seen';

// メモリキャッシュでパースコストを抑制しつつ、保存形式をコンパクトに
// 保存形式の優先度: JSON配列(["id1","id2"]) > CSV("id1,id2") > 旧JSONオブジェクト({"id":true})
let _cacheSet = null; // Set<string> | null

function loadSet() {
  if (_cacheSet) return _cacheSet;
  const raw = localStorage.getItem(localStorageKey);
  const set = new Set();
  if (!raw) {
    _cacheSet = set;
    return set;
  }
  try {
    const trimmed = raw.trim();
    if (trimmed.startsWith('[')) {
      // JSON array
      JSON.parse(trimmed).forEach((id) => set.add(String(id)));
    } else if (trimmed.startsWith('{')) {
      // legacy JSON object { id: true }
      const obj = JSON.parse(trimmed);
      Object.keys(obj).forEach((k) => set.add(String(k)));
      // 移行: よりコンパクトな配列形式へ保存
      localStorage.setItem(localStorageKey, JSON.stringify([...set]));
    } else {
      // CSV fallback
      trimmed.split(',').forEach((id) => id && set.add(id));
    }
  } catch {
    // 壊れた場合は破棄
    localStorage.removeItem(localStorageKey);
  }
  _cacheSet = set;
  return set;
}

function persistSet() {
  if (!_cacheSet) return;
  // JSON配列で保存（コンパクト＆安全）
  localStorage.setItem(localStorageKey, JSON.stringify([..._cacheSet]));
}

export const contentSeenRepository = {
  // 無期限TTL: 既読ID集合をコンパクト（JSON配列）に保存
  // 連携配信（フィードフォルダ）の仮想IDは並び順を外したキーで保存・照合する（toContentSeenKey 参照）
  set(contentId) {
    const id = toContentSeenKey(contentId);
    const set = loadSet();
    if (!set.has(id)) {
      set.add(id);
      persistSet();
    }
  },
  has(contentId) {
    const set = loadSet();
    return set.has(toContentSeenKey(contentId));
  },
  getAllIds() {
    const set = loadSet();
    return [...set];
  },
  clearAll() {
    _cacheSet = new Set();
    localStorage.removeItem(localStorageKey);
  }
};
